import {ReactElement} from "react";

type Props = {
    src: string;
    size?: number;
    style?: React.CSSProperties;
    className?: string;
    alt?: string | null;
    onClick?: () => void;
    onMouseOver?: () => void;
};

export default function Icon({src, size = 16, style, className, alt, onClick, onMouseOver}: Props): ReactElement {
    return (
        <img
            alt={alt ?? undefined}
            className={`icon-img${onClick == null ? "" : " clickable"}${
                className === undefined ? `` : ` ${className}`
            }`}
            src={src}
            style={{
                ...style,
                ...(size
                    ? { width: size, height: size }
                    : undefined),
            }}
            onClick={onClick == null ? undefined : () => {onClick();}}
            onMouseOver={onMouseOver}
        />
    );
}
